import { ListGroup } from "react-bootstrap";
import { Link } from "react-router-dom";
import TabContainerWithTabs from "../components/TabContainer";
import { useRolesResolution } from "../lib/auth";
import ReportsNav from "./ReportsNav";

const DataExports = () => {
  const { status, roles } = useRolesResolution();

  return (
    <TabContainerWithTabs tabs={ReportsNav}>
      <ListGroup>
        <ListGroup.Item>
          <Link to="balances">Account Balances</Link>
        </ListGroup.Item>
        <ListGroup.Item>
          <Link to="positions">Account Positions</Link>
        </ListGroup.Item>
        <ListGroup.Item>
          <Link to="firm-positions">Firm Positions</Link>
        </ListGroup.Item>
        <ListGroup.Item>
          <Link to="13f">13F Export</Link>
        </ListGroup.Item>
        {/*
          Administrator only: every route behind the filing wizard is gated on
          the Admin role, so offering the link to anyone else leads to a page
          they cannot use. Absent rather than disabled, as the roles arrive
          asynchronously and a disabled control would still need a reason.

          A failed token refresh is not an answer either way, so say so rather
          than withhold the link: reading it as "not an administrator" hides
          the wizard from someone entitled to it, with nothing on screen to
          explain why (APP-1453).
        */}
        {status === "error" ? (
          <ListGroup.Item className="text-danger">
            13-F Filing (review &amp; EDGAR XML) — your permissions could not be
            confirmed. Reload the page to try again.
          </ListGroup.Item>
        ) : (
          roles.includes("Admin") && (
            <ListGroup.Item>
              <Link to="13f-filing">13-F Filing (review &amp; EDGAR XML)</Link>
            </ListGroup.Item>
          )
        )}
      </ListGroup>
    </TabContainerWithTabs>
  );
};

export default DataExports;
